export const LottieAnimationFiles = {
    MerchCuration: {
        searchLoading: require("./merch/searchLoading.json"),
    },
};
